<template>
  <div>
    <list
      ref="list"
      unit="库存成本台账"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      :summaryMethod="summaryFunc"
      @reset-query="reset"
      :show-summary="summaryShow"
      @status-change="cellFun"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item label="单据周期">
          <el-select size="mini" v-model="params.Cycle" @change="cycleChange" clearable >
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="dateChange"
            clearable
          />
        </el-form-item>
        <el-form-item label="仓库名称">
          <el-select
            size="mini"
            v-model="params.WarehouseId"
            placeholder="请选择"
            @visible-change="getGoodsList"
            clearable
          >
            <el-option
              v-for="item in wareList"
              :key="item.WarehouseId"
              :label="item.WarehouseName"
              :value="item.WarehouseId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商品名称">
                <el-select
            size="mini"
            v-model="params.GoodsId"
            placeholder="请选择"
            clearable
          >
          <el-option v-for="item in GoodsList" :key="item.GoodsId" :label="item.GoodsName" :value="item.GoodsId"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="商品名称">
          <el-autocomplete
            v-model="state"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            @select="handleSelect"
            style="flex: 1; margin-right: 5px"
            :popper-append-to-body="false"
          >
          </el-autocomplete>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{ row }">
            <div v-if="row.GoodsId != 0">
              {{ $commonJs.toDateString(row.DocDate) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="GoodsName" label="商品名称" align="center" width="180px" />
        <el-table-column prop="SourceNo" label="来源单据编码" align="center" width="120px" >
          <template slot-scope="{ row }">
            <el-button type="text">{{row.SourceNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="SourceTypeName" label="来源单据类型" align="center" width="120px" />
        <el-table-column prop="Type" label="类型" min-width="80px">
          <template slot-scope="{ row }">
            <div v-if="row.GoodsId != 0">
              <span v-if="row.Type == 0">收入</span>
              <span v-if="row.Type == 1">发出</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="本期入库" align="center">
          <el-table-column prop="InQuantity" label="收入数量" align="center" />
          <el-table-column prop="InPrice" label="收入单价" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.InPrice">{{ row.InPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="InAmount" label="收入金额" align="center" />
        </el-table-column>
        <el-table-column label="本期出库" align="center">
          <el-table-column prop="OutQuantity" label="发出数量" align="center" />
          <el-table-column prop="OutPrice" label="发出单价" align="center" >
            <template slot-scope="{ row }">
              <span v-if="row.OutPrice">{{ row.OutPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="OutAmount" label="发出金额" align="center" />
        </el-table-column>
        <el-table-column label="期末结存" align="center">
          <el-table-column
            prop="BalanceQuantity"
            label="结存数量"
            align="center"
          />
          <el-table-column
            prop="BalancePrice"
            label="结存单价"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.BalancePrice">{{ row.BalancePrice }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="BalanceAmount"
            label="结存金额"
            align="center"
          />
        </el-table-column>
      </template>
    </list>

    <stock-dialog ref="stockDialog" :DisposeTax="1" />
    <orec-dialog ref="orecDialog"  />
    <prorec-dialog ref="prorecDialog"  />
    <outreturn-dialog ref="outreturnDialog"  />
    <preturn-dialog ref="preturnDialog"  />
    <out-dialog ref="outDialog"  />
    <mout-dialog ref="moutDialog"  />
    <mreturn-dialog ref="mreturnDialog"  />
    <allocation-dialog ref="allocationDialog"  />
    <sales-return-dialog ref="salesReturnDialog"  />
    <purchase-return-dialog ref="purchaseReturnDialog"  />
    <bill-dialog ref="billDialog"  />
    <oreturn-dialog ref="oreturnDialog"  />


  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

import stockDialog from "@/components/purchase/business/stock/editDialog"; //进货单
import orecDialog from "@/components/stock/bismanage/orec/detailsDialog"; //其他入库单
import prorecDialog from "@/components/stock/bismanage/prorec/detailsDialog";//产成品入库单
import outreturnDialog from "@/components/stock/bismanage/outreturn/detailsDialog";//其他出库退库单
import preturnDialog from "@/components/stock/bismanage/preturn/detailsDialog";//产成品退库单
import outDialog from "@/components/stock/bismanage/out/detailsDialog";//其他出库单
import moutDialog from "@/components/stock/bismanage/mout/detailsDialog";//材料出库单
import mreturnDialog from "@/components/stock/bismanage/mreturn/detailsDialog";//材料退库单
import allocationDialog from "@/components/stock/bismanage/allocation/detailsDialog";//调拨单
import salesReturnDialog from "@/components/sales/business/return/editDialog";//销货退货单
import purchaseReturnDialog from "@/components/purchase/business/return/editDialog";//进货货单
import billDialog from "@/components/sales/business/bill/detailsDialog";//销货单
import oreturnDialog from "@/components/stock/bismanage/oreturn/detailsDialog";//其他入库退库单


export default {
  mixins: [listMixin],
  components: { list,stockDialog,orecDialog,prorecDialog,outreturnDialog,
    preturnDialog,outDialog,moutDialog,mreturnDialog,allocationDialog,salesReturnDialog,
    purchaseReturnDialog,billDialog,oreturnDialog
   },
  data() {
    return {
      api: require("@/api/stock/costBook").default,
      wareApi: require("@/api/ba/warehouse").default,
      wareList: [],
      GoodsList: [],
      params: {
        Cycle: "今天",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
        WarehouseId: null,
        GoodsId: null
      },
      state: "",
      summaryShow: false,
      total:null
    };
  },
  mounted() {
    this.getGoodsList()
  },
  activated(){
    this.getGoodsList()
    this.getRouteQuery()
  },
  methods: {
    reset(){
      this.$emit('reset-select');
      this.state = "";
      this.Cycle = "今天";
      this.DocDateStart = this.$commonJs.getToday();
      this.DocDateEnd = this.$commonJs.getToday();
    },
    getGoodsList(){
      this.api.GoodsList().then((res) => {
      this.wareList = res.Data.Warehouses;
      let list = [];
      res.Data.Goods.forEach((e) => {
        list.push({ value: e.GoodsName, Id: e.GoodsId });
      });
      this.GoodsList = list;
      });
    },
    getRouteQuery() {
      if(this.$route.query.GoodsId){
        this.state = this.$route.query.GoodsName
        if(this.$route.query.GoodsId){
          this.params.GoodsId = Number(this.$route.query.GoodsId)
        }
        this.params.DocDateStart = this.$route.query.DocDateStart ?? null
        this.params.DocDateEnd = this.$route.query.DocDateEnd ?? null
        this.params.WarehouseId = Number(this.$route.query.WarehouseId) != 0 ? Number(this.$route.query.WarehouseId) : null
      }
      
      setTimeout(() => {
        this.$refs.list.query({ ...this.params})
      }, 500);
      
    },
    handleSelect(item) {
      this.params.GoodsId = item.Id;
    },
    querySearchAsync(queryString, cb) {
      var GoodsList = this.GoodsList;
      // console.log('queryString', queryString)
      var results = queryString
        ? GoodsList.filter(this.createStateFilter(queryString))
        : GoodsList;
      cb(results);
      // console.log('results', results)
    },
    createStateFilter(queryString) {
      return (state) => {
        // console.log('state', state, state.value.includes(queryString))
        if (state.value) {
          return (
            // state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
            state.value.includes(queryString)
          );
        }
      };
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    getDataFunc(params) {
      this.$refs.list.data = []
      return new Promise((resolve, reject) => {
        if (!this.params.WarehouseId) {
          this.$message.warning("请先选择仓库");
          resolve({ Data: [] });
        } else if (!this.params.GoodsId) {
          this.$refs.list.data = []
          this.$message.warning("请先选择商品");
          resolve({ Data: [] });
        } else if (!this.params.DocDateStart || !this.params.DocDateEnd) {
          this.$refs.list.data = []
          this.$message.warning("请先选择日期");
          resolve({ Data: [] });
        } else {
          this.api.list(params).then((res) => {
            let times = Math.ceil(res.Count / params.pageSize);
            //判断是否最后一页
            if (times == params.pageIndex) {
              this.api.ListTotal(params).then(res => {
                console.log("total", res)
                if (res.Code == 0 && res.Data) {
                  this.total = res.Data[0];
                  this.summaryShow = true;
                } else {
                  this.summaryShow = false;
                }
              })
            } else {
              this.summaryShow = false;
            }
            resolve(res);
          });
        }
      });
    },
    /** 千位符加两位小数 */
    summaryFunc(param) {
      console.log("summaryFunc", param.columns)
      const { columns, data } = param;
      var fields = ["InQuantity", "InAmount",'OutQuantity','OutAmount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          sums[index] = "";
          if (this.total) {
            if (field === 'InQuantity' || field === 'OutQuantity') {
              sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })
            } else {
              sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.StRunningAccountRptExport(this.params).then(() => {
        loading.close();
      });
    },
    cellFun(row, column){
      if (column.property == "SourceNo") {
        switch (row.SourceTypeName) {
          case "产成品入库单":
            this.$refs.prorecDialog.openDetailsById(row.SourceId);
            break;
          case "产成品退库单":
          this.$refs.preturnDialog.openDetailsById(row.SourceId);
            break;
          case "其他入库单":
            this.$refs.orecDialog.openDetailsById(row.SourceId);
            break;
          case "其他入库退库单": 
            this.$refs.oreturnDialog.openDetailsById(row.SourceId); 
            break;
          case "其他出库单":
            this.$refs.outDialog.openDetailsById(row.SourceId);
            break;
          case "其他出库退库单":
            this.$refs.outreturnDialog.openDetailsById(row.SourceId);
            break;
          case "材料出库单":
            this.$refs.moutDialog.openDetailsById(row.SourceId);
            break;
          case "材料退库单":
            this.$refs.mreturnDialog.openDetailsById(row.SourceId);
            break;
          case "调拨单":
            this.$refs.allocationDialog.openDetailsById(row.SourceId);
            break;
          case "销货单":
            this.$refs.billDialog.openDetailsById(row.SourceId); 

            // 此写法：跳转到销货单页面 搜索对应的单据并弹框
            // this.$router.push({
            //   name: "bill",
            //   params: {
            //     SourcePage:'库存成本台账',
            //     OrderId: row.SourceId,
            //     OrderNo: row.SourceNo,
            //     DocDate: row.DocDate,
            //     canWrite: this.$permission.canWrite()
            //   },
            // });
            break;
          case "销货退货单":
            this.$refs.salesReturnDialog.openEditById(row.SourceId);
            break;
          case "进货单":
            sessionStorage.setItem("check", "1");
            this.$refs.stockDialog.openEditById(row.SourceId);
            break;
          case "进货退货单":
            this.$refs.purchaseReturnDialog.openEditById(row.SourceId);
            break;
          default:
            this.$message.error("未知单据类型");
            break;
        }
      }
    }
  },
};
</script>

<style scoped>
.el-autocomplete >>> .el-autocomplete-suggestion{
  width: auto!important;
}
</style>